import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { CampaignService } from '../../../services/campaign.service';
import { Campaign } from '../../../shared/campaign/campaign.model';
import { ClientService } from '../../../services/client.service';
import { Globals } from '../../../global';

@Component({
	selector: 'app-campaigns-list',
	templateUrl: './campaigns-list.component.html',
	styleUrls: ['./campaigns-list.component.css']
})
export class CampaignsListComponent implements OnInit, OnChanges {
	@Input() clientId: string;
	role: string;
	campaign: Campaign = new Campaign();
	event:any;
	clients:any;
	mode: string;
	campaignId: string = "";
	userToDelete: string;
	public data: any;
	public rowsOnPage: number = 10;
	public filterQuery: string = "";
	public sortBy: string = "";
	public sortOrder: string = "desc";

	constructor(public campaignService: CampaignService, public authService: AuthService, public clientService: ClientService, private globals: Globals) {
		this.role = JSON.parse(localStorage.getItem('user')).data.role;
	}

	getAll() {
		this.campaignService.getAll()
			.subscribe((data:any) => {
				this.data = data.data;
				this.filterData();
			}, (err:any) => {
				if (err.status === 401) {
					this.authService.logout();
				}
			});
	}

	getCampaign(id) {
		this.campaignService.getCampaign(id)
			.subscribe((data:any)=> {
				this.campaign = data.data;
				this.campaign.startDate = this.decodeDate(this.campaign.startDate);
			}, (err:any) => {
				if (err.status === 401) {
					this.authService.logout();
				}
			});
	}

	getCampaignByClient() {
		this.campaignService.getCampaignByClient(this.clientId)
			.subscribe((data:any)=> {
				this.data = data.data;
				localStorage.setItem('campaign', JSON.stringify(this.data[0]));
				let campaigns: any = [];
				this.data.forEach(element => {
					campaigns.push(new Campaign().deserialize(element));
				});
				this.data = campaigns;
				this.filterData();
			}, (err:any) => {
				if (err.status === 401) {
					this.authService.logout();
				}
			});
	}

	save() {
		const body = {
			name: this.campaign.name,
			description: this.campaign.description,
			amount: this.campaign.amount,
			goal: this.campaign.goal,
			cpl: this.campaign.cpl,
			client: this.clientId,
			startDate: this.getDate(this.campaign.startDate)
		}

		if (this.campaign.endDate) {
			body['endDate'] = this.getDate(this.campaign.endDate)
		}
		
		if (this.campaignId !== "") {
			this.campaignService.update(body, this.campaignId)
				.subscribe((data:any) => {
					if (data.success === true) {
						this.getCampaignByClient();
						document.querySelector("#"+this.event).classList.remove('md-show');
					} else {}
				})
		} else {
			this.campaignService.create(body)
				.subscribe((data:any) => {
					if (data.success === true) {
						this.getCampaignByClient();
						document.querySelector("#"+this.event).classList.remove('md-show');
					} else {}
				})
		}
	}

	confirmDelete(id) {
		this.userToDelete = id;
		document.querySelector("#confirmation").classList.add('md-show');
	}

	delete() {
		this.campaignService.delete(this.userToDelete)
			.subscribe((data:any) => {
				if (data.success === true) {
					this.getCampaignByClient();
					document.querySelector("#confirmation").classList.remove('md-show');
				} else {
					console.log(data);
				}
			});
	}

	getDate(date) {
		return new Date(date.year, date.month - 1, date.day);
	}
	
	decodeDate(date) {
		let newDate = new Date(date);

		return {
			year: newDate.getFullYear(),
			month: newDate.getMonth() + 1,
			day: newDate.getDate()
		};
	}
	
	filterData() {
		let actives = [];
		this.data.forEach(element => {
			if (element.status === "active") {
				actives.push(element);
			}
		});

		this.data = actives;
	}

	// SE EJECUTA AL CARGAR EL COMPONENTE
	ngOnInit() {
	}

	ngOnChanges(): void {
		//Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
		//Add '${implements OnChanges}' to the class.
		if (this.clientId) {
			this.getCampaignByClient();
		}
	}

	openMyModal(event, campaignId=null) {
		document.querySelector("#"+event).classList.add('md-show');
		this.event = event;

		if (campaignId !== null) {
			this.getCampaign(campaignId);
			this.campaignId = campaignId;
		} else {
			this.campaignId = "";
			this.campaign = new Campaign();
		}
	}

	closeMyModal(event) {
		((event.target.parentElement.parentElement).parentElement).classList.remove('md-show');
	}

}



// WEBPACK FOOTER //
// ./src/app/components/campaigns/list/campaigns-list.component.ts